import React, { useState } from "react";

import { Col, Container, Row, ListGroup } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { websiteData } from "../../../utils/data";

import "../footer/footer.css";
const Footer = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (typeof window !== "undefined") {
    window.addEventListener("scroll", toggleVisible);
  }

  return (
    <>
      <footer className="pt-5">
        <Container>
          <Row>
            <Col md="4" sm="12" className="quick_link mt-3 mt-md-0 ">
              <h4 className="mt-lg-0 mt-sm-3">Company </h4>
              <p>
                Elevating brands through
                <br />
                digital innovation and video.
              </p>
            </Col>

            <Col md="4" sm="12" className="quick_link mt-3 mt-md-0 ">
              <h4 className="mt-lg-0 mt-sm-3">Quick Links </h4>
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <NavLink to="/"> Home</NavLink>
                </ListGroup.Item>
                <ListGroup.Item>
                  <NavLink to="/about-us">About Us </NavLink>
                </ListGroup.Item>
                <ListGroup.Item>
                  <NavLink to="/contact-us"> Contact Us </NavLink>
                </ListGroup.Item>
              </ListGroup>
            </Col>
            <Col md="4" sm="12" className="location mt-3 mt-md-0 ">
              <h4 className="mt-lg-0 mt-sm-3">Contact Info </h4>

              <div className="d-flex align-items-center">
                <p className="pb-2">{websiteData.address}</p>
              </div>

              <div className="d-flex align-items-top my-2">
                <i className="bi bi-geo-alt me-3"></i>
                <a
                  target="_blank"
                  href={`mailto:${websiteData.email}`}
                  className="d-block"
                >
                  {websiteData.email}
                </a>
              </div>
              <div className="d-flex align-items-top ">
                <i className="bi bi-telephone me-3"></i>
                <a
                  target="_blank"
                  href={`tel:${websiteData.phone_one}`}
                  className="d-block"
                >
                  {websiteData.phone_one}
                </a>
              </div>
            </Col>
          </Row>
          <Row className="py-2 bdr mt-3 justify-content-between">
            <Col xs={12} sm={6} className="copyright">
              <p className="text-light dev_company">
                Copyright <i className="bi bi-c-circle"></i>&nbsp;
                {new Date().getFullYear()}&nbsp;
                <a target="_blank" href={`${websiteData.instagram}`}>
                  {websiteData.company_name}
                </a>
                .&nbsp;All rights reserved.
              </p>
            </Col>
            <Col xs={12} sm={6} className="d-flex justify-content-md-end ">
              <p className="text-light dev_company">
                Website designed & developed by&nbsp;
                <a target="_blank" href={`${websiteData.dev_company_url}`}>
                  {websiteData.dev_company}
                </a>
              </p>
            </Col>
          </Row>
        </Container>
      </footer>

      <div
        id="back-top"
        onClick={scrollTop}
        className={visible ? "active" : ""}
      >
        <i className="bi bi-arrow-up"></i>
      </div>
    </>
  );
};

export default Footer;
